import { useTranslate } from 'react-polyglot';

import type { ButtonProps } from '@genially/design-system';
import { Button } from '@genially/design-system';
import { CopyIcon } from '@genially/icons';

import { useCopySessionLink } from '../../hooks/useCopySessionLink';

interface CopyLinkButtonProps {
  variant?: ButtonProps['variant'];
  from?: 'game' | 'lobby';
}

export const CopyLinkButton = ({
  variant = Button.Variant.STROKE_REVERSED,
  from = 'lobby',
}: CopyLinkButtonProps) => {
  const t = useTranslate();

  const { handleCopySessionClick } = useCopySessionLink(from);

  return (
    <Button
      StartIcon={<CopyIcon />}
      variant={variant}
      size={Button.Size.MEDIUM}
      onClick={handleCopySessionClick}
    >
      {t('__new.play.creatorLobby.copyLink.button')}
    </Button>
  );
};
